module.exports = __webpack_public_path__ + "static/media/EmployerInformation.ed4256ba.svg";